import React from 'react';

const BehavioralHeatmap = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No heatmap data available
      </div>
    );
  }

  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const getIntensityColor = (intensity) => {
    if (intensity >= 80) return 'bg-success';
    if (intensity >= 60) return 'bg-primary';
    if (intensity >= 40) return 'bg-warning';
    if (intensity >= 20) return 'bg-warning/50';
    return 'bg-muted';
  };

  const getDataForCell = (day, hour) => {
    return data?.find(d => d?.day === day && d?.hour === hour);
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[600px]">
        {/* Hour Labels */}
        <div className="flex mb-2">
          <div className="w-12"></div>
          {hours?.map((hour) => (
            <div key={hour} className="flex-1 text-center text-xs text-muted-foreground">
              {hour % 3 === 0 ? `${hour}h` : ''}
            </div>
          ))}
        </div>

        {/* Heatmap Grid */}
        {days?.map((day) => (
          <div key={day} className="flex items-center mb-1">
            <div className="w-12 text-xs font-medium text-muted-foreground">{day}</div>
            {hours?.map((hour) => {
              const cellData = getDataForCell(day, hour);
              const intensity = cellData?.intensity || 0;
              return (
                <div
                  key={`${day}-${hour}`}
                  className={`flex-1 h-8 mx-0.5 rounded ${getIntensityColor(intensity)} transition-all hover:scale-110 cursor-pointer`}
                  title={`${day} ${hour}:00 - Activity: ${intensity}%`}
                />
              );
            })}
          </div>
        ))}

        {/* Legend */}
        <div className="mt-6 flex items-center justify-center gap-4 text-xs">
          <span className="text-muted-foreground">Activity Level:</span>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-muted"></div>
            <span className="text-muted-foreground">Low</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-warning/50"></div>
            <span className="text-muted-foreground">Medium</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-primary"></div>
            <span className="text-muted-foreground">High</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-success"></div>
            <span className="text-muted-foreground">Very High</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BehavioralHeatmap;